"use strict";

angular.module('PatientApp').factory('BillsService', function (VuexStore, VueEventTransmitter, Models) {
  // Register this service to clear it's data when asked to
  VueEventTransmitter.$on('data:clear', function () {
    VuexStore.commit('setCurrentBill', null);
  });
  return {
    createBill: function createBill(bill) {
      // if we are passing an already created bill
      // object just return it
      if (bill instanceof Models.Bill) {
        return bill;
      }

      return new Models.Bill(bill, null);
    },
    isBill: function isBill(bill) {
      return bill instanceof Models.Bill;
    },

    /**
    If we have a current bill in memory share it
    */
    getCurrentBill: function getCurrentBill() {
      return VuexStore.state.BillsStore.currentBill;
    },

    /**
    remove the current bill from memory
    */
    flushCurrentBill: function flushCurrentBill() {
      VuexStore.commit('setCurrentBill', null);
    },

    /**
    Look up a bill based on scode and amount with our
    server. Should be called when finding the bill from
    the landing screen for an unauthed user.
    */
    find: function find(sCode, amount) {
      return VuexStore.dispatch('findBill', {
        secureCode: sCode,
        billAmount: amount
      });
    },

    /**
    Look up the bill similar to the find method but our intent
    is also to link the bill with the currently logged in user
    */
    link: function link(sCode, amount) {
      return VuexStore.dispatch('linkBill', {
        sCode: sCode,
        amount: amount
      });
    },

    /**
    Look up bill based on the sCode alone. This search will
    look only under the currently logged in user's account to find
    a bill that matches on that.
    */
    getAccountBill: function getAccountBill(sCode) {
      return VuexStore.dispatch('getAccountBill', sCode);
    },
    // Look up a bill based on the CCI pub id
    getCCIBill: function getCCIBill(pubId) {
      return VuexStore.dispatch('getCCIBill', pubId);
    },
    // utility to open the pdf in the correct location
    openPdf: function openPdf(sCode) {
      return VuexStore.dispatch('openPdf', sCode);
    },
    // Get verification options from firstBill token
    findAuthOptions: function findAuthOptions(token) {
      return VuexStore.dispatch('findAuthOptionsBill', token);
    },
    markOpened: function markOpened(token) {
      return VuexStore.dispatch('markOpenedBill', token);
    },
    findNew: function findNew(token, verificationCode, guarantorLast4SSN, guarantorDOB, zip) {
      return VuexStore.dispatch('findNewBill', {
        token: token,
        verificationCode: verificationCode,
        guarantorLast4SSN: guarantorLast4SSN,
        guarantorDOB: guarantorDOB,
        zip: zip
      });
    },
    firstBillGetCode: function firstBillGetCode(token) {
      return VuexStore.dispatch('firstBillGetCode', token);
    },
    payAsGuest: function payAsGuest() {
      return VuexStore.dispatch('payAsGuest');
    }
  };
});